export default __webpack_public_path__ + "static/media/t1-p1-v1.5f22405d.mp4";